import { Input } from "components/base";
import { Flex } from "components/base/container";
import { NumberInput } from "components/form";
import styled from "styled-components";

export const DetailSetupInput = styled(Input)``;
DetailSetupInput.defaultProps = {
  bg: "transparent",
  height: "42px",
  px: "20px",
  border: "1px solid #D2C7D9",
  borderRadius: "8px",
  color: "#D2C7D9",
};
export const DetailSetupNumInput: React.FC<{
  [index: string]: any;
}> = ({ children, ...props }) => {
  return (
    <NumberInput
      type={"number"}
      bg={"transparent"}
      px={"20px"}
      border={"1px solid #D2C7D9"}
      borderRadius={"8px"}
      color={"#D2C7D9"}
      height={"42px"}
      {...props}
    />
  );
};

export const ConfirmValueBox = styled(Flex)``;
ConfirmValueBox.defaultProps = {
  p: "8px 16px",
  borderBottom: "1px solid #D2C7D950",
  fontWeight: "400",
  fontSize: "16px",
  lineHeight: "130%",
};

export const DetailSetupInputTitle = styled(Flex)``;
DetailSetupInputTitle.defaultProps = {
  fontWeight: "700",
  fontSize: "18px",
  lineHeight: "100%",
};
